import {
  TypographyList,
  TypographyListItem,
  makeStyles,
} from '@gogame/components';

const useStyles = makeStyles({
  paperClass: {
    width: 600,
  },
});

const BatchItemsList = ({ data = [] }) => {
  const classes = useStyles();

  return (
    <TypographyList
      unitsLabel={'items selected'}
      limit={20}
      PaperProps={{ className: classes.paperClass }}
    >
      {data.map((el) => (
        <TypographyListItem type={'bullet'}>{el.name}</TypographyListItem>
      ))}
    </TypographyList>
  );
};

export default BatchItemsList;
